import { getVietnamDateKey } from "@/lib/topup-promo";

/** Không khí Tết Trung Thu — trùng thời gian sự kiện điểm danh tháng 9/2026. */
export const TRUNG_THU_SEASON_START = "2026-09-02";
export const TRUNG_THU_SEASON_END = "2026-09-30";
export const TRUNG_THU_LABEL = "Mừng Trung Thu 2026";

export function isTrungThuSeason(date: Date = new Date()): boolean {
  const key = getVietnamDateKey(date);
  return key >= TRUNG_THU_SEASON_START && key <= TRUNG_THU_SEASON_END;
}
